import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/navbar";

import screen1 from "../assets/1__Role-Based_Home_Screen.jpg";
import screen2 from "../assets/2__Compliance_Stepper_Screen.jpg";
import screen3 from "../assets/3__Different_Input_Types_Screen.jpg";
import screen4 from "../assets/4__Geo_Validation_Screen.jpg";
import screen5 from "../assets/5__Compliance_Summary_Screen.jpg";
import screen6 from "../assets/6__Approval_Decision_Screen.jpg";
import screen7 from "../assets/7__Fire___Safety_Review_Screen.jpg";
import screen8 from "../assets/8__Hard_Gate_Experience_Screen.jpg";

const SPECS = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='28' viewBox='0 0 48 28'%3E%3Crect x='1' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Crect x='29' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Cpath d='M19 13 L29 13' stroke='%231a1a1a' stroke-width='2.5' stroke-linecap='round'/%3E%3Cpath d='M1 13 L0 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M47 13 L48 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E`;

const css = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;scroll-behavior:smooth}

body{
  background:#fafafa;
  background-image:linear-gradient(rgba(0,0,0,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(0,0,0,0.045) 1px,transparent 1px);
  background-size:32px 32px;
  font-family:'DM Sans',sans-serif;
  color:#111;
  cursor:url("${SPECS}") 24 14,auto;
}
a,button{cursor:url("${SPECS}") 24 14,pointer}

@keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
.d0{animation:fadeUp .5s .00s ease both}
.d1{animation:fadeUp .5s .10s ease both}
.d2{animation:fadeUp .5s .20s ease both}
.d3{animation:fadeUp .5s .30s ease both}
.reveal{opacity:0;transform:translateY(16px);transition:opacity .6s ease,transform .6s ease}
.reveal.in{opacity:1;transform:translateY(0)}

.back{display:inline-flex;align-items:center;gap:8px;font-size:11px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:#aaa;background:none;border:none;padding:0;transition:color .15s}
.back:hover{color:#111}

.mlabel{font-size:11px;font-weight:500;color:#aaa;letter-spacing:.08em;display:block;margin-bottom:10px}
.lh{font-size:clamp(28px,4.5vw,46px);font-weight:800;letter-spacing:-0.03em;line-height:1.1;color:#111}
.bt{font-size:15px;color:#555;line-height:1.85}
.hl{background:#fde047;padding:0 3px;border-radius:2px;font-style:normal}
.bq{border-left:3px solid #111;padding-left:20px;font-size:16px;font-weight:600;color:#111;line-height:1.5}
.div{border:none;border-top:1px solid #e8e8e8;margin:0}
.prog{transition:width .3s}

.ph{border-radius:0;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.14);background:#111;flex-shrink:0}
.ph img{width:100%;display:block}

.ann-dot{width:8px;height:8px;border-radius:50%;background:#111;flex-shrink:0;margin-top:7px}
.ann-line{width:32px;height:1px;background:#ddd;flex-shrink:0;align-self:center}

::-webkit-scrollbar{width:3px}
::-webkit-scrollbar-thumb{background:#ddd;border-radius:4px}

@media(max-width:900px){
  .four-col{grid-template-columns:repeat(2,1fr)!important}
  .role-grid{grid-template-columns:repeat(2,1fr)!important}
  .six-col{grid-template-columns:repeat(2,1fr)!important}
}
@media(max-width:640px){
  .sc-grid{flex-direction:column!important}
  .sc-grid>*{width:100%!important;flex-basis:auto!important}
  .two-col{grid-template-columns:1fr!important}
  .three-col{grid-template-columns:1fr!important}
  .four-col{grid-template-columns:1fr!important}
  .role-grid{grid-template-columns:1fr!important}
  .six-col{grid-template-columns:1fr!important}
  main{padding:20px 16px 64px!important}
  .lh{font-size:clamp(22px,6vw,32px)!important}
  .bt{font-size:14px!important}
  .ph{width:100%!important;max-width:280px;margin:0 auto}
}
`;

function useWidth() {
  const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  useEffect(() => {
    const fn = () => setW(window.innerWidth);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return w;
}

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { el.classList.add("in"); obs.disconnect(); }
    }, { threshold:.06 });
    obs.observe(el); return () => obs.disconnect();
  }, []);
  return ref;
}
function Sec({ children, style }) {
  const r = useReveal();
  return <section ref={r} className="reveal" style={{ marginBottom:88,...style }}>{children}</section>;
}

/* ── IA Tree Component ── */
function IATree() {
  const modules = [
    { name:"Authentication", items:["Login","OTP Verification","Forgot Password"] },
    { name:"Dashboard", items:["Pending Actions","Active Permits","Notifications","Quick Actions"] },
    { name:"Work Permits", items:["Create Permit","Draft / Submitted / Active","Suspended / Extended / Closed"] },
    { name:"Compliance & JSA", items:["Safety Checklist","JSA Upload","Photo Capture","Gas Test Reports","GPS Verification"] },
    { name:"Approval Workflow", items:["Permit Issuer Review","F&S Review","OIC Approval","Final Permit Issue"] },
    { name:"Permit Management", items:["Suspension","Extension Request","Beyond Shift Approval","Closure Request"] },
    { name:"Reports", items:["Open / Closed / Suspended","Hot Work / Cold Work","Export Reports"] },
    { name:"Notifications", items:["Approval Updates","Returned Requests","Expiry & Closure Alerts"] },
    { name:"Profile", items:["User Details","Assigned Role","Logout"] },
  ];
  return (
    <div style={{ border:"1px solid #e8e8e8", borderRadius:4, overflow:"hidden", background:"#fff" }}>
      <div style={{ padding:"16px 24px", borderBottom:"1px solid #e8e8e8", background:"#111" }}>
        <p style={{ fontSize:13, fontWeight:700, color:"#fff", letterSpacing:".04em" }}>Industrial Gas Work Permit App</p>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", borderTop:"none" }}>
        {modules.map((m,i) => (
          <div key={i} style={{ padding:"16px 20px", borderRight: i%3<2 ? "1px solid #e8e8e8" : "none", borderBottom:"1px solid #e8e8e8" }}>
            <p style={{ fontSize:12, fontWeight:700, color:"#111", marginBottom:8 }}>{m.name}</p>
            {m.items.map((it,j) => (
              <p key={j} style={{ fontSize:11.5, color:"#888", lineHeight:1.7, paddingLeft:10, borderLeft:"1.5px solid #e8e8e8" }}>
                {it}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── Workflow flow component ── */
function WorkflowFlow({ title, color="#111", steps=[], decision=null }) {
  return (
    <div>
      <p style={{ fontSize:12, fontWeight:700, color, letterSpacing:".06em", textTransform:"uppercase", marginBottom:14 }}>{title}</p>
      <div style={{ display:"flex", flexDirection:"column", gap:0 }}>
        {steps.map((s,i) => (
          <div key={i} style={{ display:"flex", gap:0 }}>
            <div style={{ display:"flex", flexDirection:"column", alignItems:"center", width:28 }}>
              <div style={{ width:8, height:8, borderRadius:"50%", background: s.highlight ? color : "#ddd", flexShrink:0, marginTop:5 }} />
              {i < steps.length-1 && <div style={{ width:1, flex:1, background:"#e8e8e8", minHeight:8 }} />}
            </div>
            <p style={{ fontSize:13, color: s.highlight ? "#111" : "#888", fontWeight: s.highlight ? 600 : 400, marginLeft:8, paddingBottom:6, lineHeight:1.5 }}>{s.label}</p>
          </div>
        ))}
        {decision && (
          <div style={{ marginLeft:28, marginTop:4, display:"flex", gap:16 }}>
            {decision.map((d,i) => (
              <div key={i} style={{ display:"flex", alignItems:"center", gap:6 }}>
                <div style={{ width:6, height:6, borderRadius:"50%", background: i===0 ? "#22c55e" : i===1 ? "#f59e0b" : "#ef4444" }} />
                <p style={{ fontSize:12, color:"#777" }}>{d}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════ MAIN */
export default function CaseStudy1() {
  const [prog, setProg] = useState(0);
  const navigate = useNavigate();
  const w = useWidth();
  const isMobile = w < 640;
  const isTablet = w < 900;
  useEffect(() => {
    const fn = () => { const el = document.documentElement; setProg((el.scrollTop/(el.scrollHeight-el.clientHeight))*100); };
    window.addEventListener("scroll",fn); return ()=>window.removeEventListener("scroll",fn);
  },[]);

  return (
    <div style={{ background:"#fafafa", minHeight:"100vh", backgroundImage:"linear-gradient(rgba(0,0,0,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(0,0,0,0.045) 1px,transparent 1px)", backgroundSize:"32px 32px" }}>
      <style>{css}</style>
      <div style={{ position:"fixed",top:0,left:0,right:0,height:3,background:"rgba(0,0,0,0.07)",zIndex:100 }}>
        <div className="prog" style={{ height:"100%",background:"#111",width:`${prog}%` }} />
      </div>

      <Navbar />

      <main style={{ padding:"40px 7vw 100px" }}>

        {/* ── back ── */}
        <div className="d0" style={{ marginBottom:40 }}>
          <button className="back" onClick={()=>navigate("/")}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M9 2L4 7l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            Back
          </button>
        </div>

        {/* ══ HERO ══════════════════════════════════════════════ */}
        <section style={{ marginBottom:80 }}>
          <div className="d0" style={{ display:"flex",gap:8,flexWrap:"wrap",marginBottom:20 }}>
            {["Mobile App","Enterprise B2B","Safety-Critical UX","NDA Safe"].map(t=>(
              <span key={t} style={{ fontSize:11,fontWeight:500,color:"#888",background:"#f0f0f0",borderRadius:999,padding:"3px 12px" }}>{t}</span>
            ))}
          </div>
          <h1 className="d1 lh" style={{ marginBottom:20 }}>
            Digitizing Work Permits for Industrial Gas
          </h1>
          <p className="d2 bt" style={{ marginBottom:36 }}>
            Industrial maintenance teams were managing safety-critical work permits entirely on paper.
            Missing a single compliance step could delay operations — or worse, create serious safety risks.
            I designed a mobile work permit system that <span className="hl">digitized approvals while ensuring mandatory safety checks could never be skipped</span>.
          </p>
          <div className="d3" style={{ display:"flex",flexWrap:"wrap",gap:40,paddingTop:24,borderTop:"1px solid #e8e8e8" }}>
            {[{l:"Client",v:"Industrial Gas Limited (IGL)"},{l:"Platform",v:"Mobile — Android Hybrid"},{l:"Duration",v:"May – Aug 2024"},{l:"Role",v:"UI/UX Designer, End-to-end"},{l:"Team",v:"1 Designer · 1 BA · 3 Devs"}].map(m=>(
              <div key={m.l}>
                <p style={{ fontSize:10,fontWeight:600,letterSpacing:".14em",textTransform:"uppercase",color:"#bbb",marginBottom:4 }}>{m.l}</p>
                <p style={{ fontSize:13,fontWeight:600 }}>{m.v}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── HERO SCREENS ── */}
        <Sec>
          <div style={{ background:"#111",padding:"32px 28px 28px" }}>
            <p style={{ fontSize:10,fontWeight:600,letterSpacing:".2em",textTransform:"uppercase",color:"#444",textAlign:"center",marginBottom:24 }}>8 screens · 4 user roles · 1 system</p>
            <div style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12 }}>
              {[screen1,screen2,screen5,screen8].map((s,i)=>(
                <img key={i} src={s} alt="" style={{ width:"100%",display:"block" }} />
              ))}
            </div>
          </div>
        </Sec>

        {/* ══ PRODUCT HIGHLIGHTS ══════════════════════════════════ */}
        <Sec>
          <span className="mlabel">Product Highlights</span>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="four-col">
            {[
              { num:"4", title:"Primary User Roles", sub:"Permit Receiver · Permit Issuer · F&S Officer · OIC" },
              { num:"25", title:"Mandatory Safety Checks", sub:"Step-by-step verification" },
              { num:"Role-Based", title:"Different workflows", sub:"Single application" },
              { num:"Offline Ready", title:"Designed for industrial field environments", sub:"GPS-aware" },
            ].map((m,i)=>(
              <div key={i} style={{ padding:"28px 24px",background:"#fff" }}>
                <p style={{ fontSize:'clamp(28px,4vw,40px)',fontWeight:800,letterSpacing:"-0.03em",lineHeight:1.1,marginBottom:10,color:"#111" }}>{m.num}</p>
                <p style={{ fontSize:13,fontWeight:600,marginBottom:4,color:"#111" }}>{m.title}</p>
                <p style={{ fontSize:12,color:"#aaa" }}>{m.sub}</p>
              </div>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ CONTEXT ══════════════════════════════════════════════ */}
        <Sec>
          <span className="mlabel">Context</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Paper permits were failing field workers in four critical ways.</h2>
          <p className="bt" style={{ marginBottom:20 }}>
            This project wasn't simply about replacing paper with a mobile app. The challenge was to improve operational efficiency while ensuring that
            safety compliance became <span className="hl">easier — not easier to bypass</span>.
          </p>
          <p className="bt" style={{ marginBottom:36 }}>
            Industrial Gas Limited operates safety-critical sites where every maintenance job requires a formal Work Permit.
            The existing system was entirely paper-based, creating four measurable failure modes that affected safety, compliance, and efficiency.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:32 }} className="two-col">
            {[
              { label:"Zero status visibility", body:"No way to see where a permit was in the approval chain. Workers physically visited 4 departments to check progress." },
              { label:"Incomplete compliance", body:"25+ item checklists were frequently skipped. No enforcement mechanism — a missed gas test went undetected." },
              { label:"No geo-verification", body:"Approvals happened from offices, not the field. No way to verify a worker was physically on-site." },
              { label:"Role confusion", body:"A single form served 4 different roles. Everyone saw the same screen regardless of their authority." },
            ].map((f,i)=>(
              <div key={i} style={{ padding:"22px 22px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{f.label}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{f.body}</p>
              </div>
            ))}
          </div>
          <div className="bq">
            "How do we build a permit system that makes compliance impossible to skip — without slowing down field workers who are already under pressure?"
          </div>
        </Sec>

        {/* ── WHY PAPER FAILED (NEW) ── */}
        <Sec>
          <span className="mlabel">Why Paper Failed</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Paper permits looked familiar, but they introduced operational risks that became more serious as projects scaled.</h2>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="four-col">
            {[
              { t:"Mandatory steps skipped", b:"Workers could accidentally miss safety checks." },
              { t:"Limited visibility", b:"Approvers had no real-time status." },
              { t:"Slow approvals", b:"Paper moved slower than field work." },
              { t:"No accountability", b:"No reliable audit trail." },
            ].map((c,i)=>(
              <div key={i} style={{ padding:"22px 20px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{c.t}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{c.b}</p>
              </div>
            ))}
          </div>
        </Sec>

        {/* ── USER VOICES / PERSONAS ── */}
        <Sec>
          <span className="mlabel">User Research</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Four roles. Four different goals. Four different pain points.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            No direct user access during this project — I had a 28-page BRD and stakeholder calls.
            The goals and pain points below were synthesised from field reports and operations reviews.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="four-col">
            {[
              { role:"Permit Receiver", goal:"Complete the work permit quickly and safely.", pain:"Paper-based checklists were time-consuming and required repeated verification." },
              { role:"Permit Issuer", goal:"Approve only fully compliant permits.", pain:"Missing documents delayed approvals and created uncertainty." },
              { role:"F&S Officer", goal:"Verify site safety before work begins.", pain:"Limited visibility into permit progress and missing compliance evidence." },
              { role:"OIC", goal:"Provide final authorization confidently.", pain:"Paper documentation made it difficult to trust whether every mandatory step had actually been completed." },
            ].map((u,i)=>(
              <div key={i} style={{ background:"#fff",padding:"22px 20px",borderTop:"2px solid #111" }}>
                <p style={{ fontSize:13,fontWeight:800,color:"#111",marginBottom:14 }}>{u.role}</p>
                <p style={{ fontSize:10,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#bbb",marginBottom:4 }}>Goal</p>
                <p style={{ fontSize:12.5,color:"#555",lineHeight:1.55,marginBottom:14 }}>{u.goal}</p>
                <p style={{ fontSize:10,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#bbb",marginBottom:4 }}>Pain Point</p>
                <p style={{ fontSize:12.5,color:"#777",lineHeight:1.55 }}>{u.pain}</p>
              </div>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ INFORMATION ARCHITECTURE ══════════════════════════════ */}
        <Sec>
          <span className="mlabel">Information Architecture</span>
          <h2 className="lh" style={{ marginBottom:16 }}>I mapped the full system before designing a single screen.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            Working from a 28-page BRD, I identified 9 top-level modules, 4 distinct user roles, and 3 decision branches
            before opening Figma. <span className="hl">System clarity before visual clarity.</span>
          </p>
          <IATree />
        </Sec>

        {/* ── DESIGN PRINCIPLES (NEW) ── */}
        <Sec>
          <span className="mlabel">Design Principles</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Six principles that guided every screen decision.</h2>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="six-col">
            {[
              { t:"Safety before speed", b:"Compliance should never be sacrificed for faster completion." },
              { t:"Task first", b:"Show workers what they need to do next — not every feature." },
              { t:"Role-aware design", b:"Different responsibilities require different interfaces." },
              { t:"No skipped compliance", b:"Mandatory safety checks must be completed before approval." },
              { t:"Offline first", b:"Workers should continue working even with poor connectivity." },
              { t:"Clear recovery", b:"When something blocks submission, explain why and how to resolve it." },
            ].map((c,i)=>(
              <div key={i} style={{ padding:"22px 20px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{c.t}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{c.b}</p>
              </div>
            ))}
          </div>
        </Sec>

        {/* ══ ROLE WORKFLOWS ══════════════════════════════════════ */}
        <Sec>
          <span className="mlabel">Role Workflows</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Four roles. One system. Different experiences.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            Each role has a distinct mental model and environment.
            I designed <span className="hl">role-aware rendering</span> — the home screen builds dynamically from whoever is logged in, not 4 separate apps.
          </p>
          <div className="four-col role-grid" style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }}>
            {[
              { title:"Permit Receiver", user:"Field worker / contractor", goal:"Obtain permit and start work safely",
                steps:[{label:"Login & Dashboard"},{label:"Create Permit Request",highlight:true},{label:"Enter Work Details"},{label:"Submit Request"},{label:"Complete Compliance",highlight:true},{label:"GPS Validation",highlight:true},{label:"Track Approval Status"},{label:"Start Work"},{label:"Request Closure"}],
                decision:null },
              { title:"Permit Issuer", user:"Engineer / supervisor", goal:"Ensure work can be safely executed",
                steps:[{label:"View New Requests"},{label:"Verify Work Details"},{label:"Define Compliance"},{label:"Review Submitted Compliance",highlight:true},{label:"Review GPS Verification",highlight:true},{label:"Decision",highlight:true},{label:"Issue Permit"},{label:"Monitor Work"},{label:"Close Permit"}],
                decision:["Approve","Return","Reject"] },
              { title:"F&S Officer", user:"Fire & Safety officer", goal:"Prevent ignition / hazardous incidents",
                steps:[{label:"View Hot Work Permits"},{label:"Review Gas Readings",highlight:true},{label:"Review JSA"},{label:"Review Safety Controls"},{label:"Decision",highlight:true},{label:"Monitor High-Risk Work"}],
                decision:["Approve","Return"] },
              { title:"OIC", user:"Operations In-Charge", goal:"Approve exceptional scenarios",
                steps:[{label:"Review Extension Requests"},{label:"Review Work Status"},{label:"Risk Assessment",highlight:true},{label:"Decision",highlight:true},{label:"Notify Stakeholders"}],
                decision:["Approve","Reject"] },
            ].map((r,i)=>(
              <div key={i} style={{ background:"#fff",padding:"20px 18px" }}>
                <p style={{ fontSize:12,fontWeight:800,color:"#111",marginBottom:3 }}>{r.title}</p>
                <p style={{ fontSize:11,color:"#aaa",marginBottom:3 }}>{r.user}</p>
                <p style={{ fontSize:11,color:"#888",fontStyle:"italic",marginBottom:16,lineHeight:1.4 }}>Goal: {r.goal}</p>
                <WorkflowFlow steps={r.steps} decision={r.decision} />
              </div>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ DESIGN DECISIONS ══════════════════════════════════════ */}

        {/* ── 01 Role-Based Home ── */}
        <Sec>
          <span className="mlabel">Design Decision 01</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Role-based home screen — task first, not feature first.</h2>
          <p className="bt" style={{ marginBottom:36 }}>
            The original app showed all 4 roles the same grid of two-letter shortcuts (WR, CP, PR). No hierarchy, no status —
            workers had to decode abbreviations before they could even start their task. I designed <span className="hl">role-aware rendering</span> instead:
            the home screen builds dynamically from whoever is logged in. The tradeoff was more engineering complexity behind a single screen, in exchange for zero learning curve for the worker.
          </p>

          <div style={{ display:"flex",gap:0,alignItems:"flex-start",background:"#fff",border:"1px solid #e8e8e8",flexDirection:isMobile?"column":"row" }}>
            <div style={{ flexShrink:0,width:isMobile?"100%":"42%",background:"#f7f3f0",display:"flex",alignItems:"center",justifyContent:"center",padding:isMobile?"28px 20px":"40px 32px" }}>
              <div className="ph" style={{ width:isMobile?"100%":240,maxWidth:280 }}><img src={screen1} alt="Role home" /></div>
            </div>
            <div style={{ flex:1,minWidth:0,padding:"clamp(20px,4vw,40px) clamp(20px,4vw,36px)",display:"flex",flexDirection:"column",gap:24 }}>
              {[
                { label:"Role badge at top", body:"'PERMIT RECEIVER' badge tells the worker whose workflow this is before they read anything on screen. Context before action." },
                { label:"Full-width primary CTA", body:"'Create Work Permit Request' dominates the top as a dark high-contrast card — impossible to miss under outdoor lighting or in a hard hat." },
                { label:"URGENT / RE-WORK urgency tags", body:"Color + label = instant triage. Workers prioritise in under 2 seconds without reading permit details." },
                { label:"Status as scannable numbers", body:"'03 Under Review · 12 Approved' — numbers replace long lists. Full picture at a glance." },
                { label:"Zero abbreviations", body:"WR, CP, PR, PE are gone. Every label is a full English word — mandatory for glove-use environments." },
              ].map((a,i)=>(
                <div key={i} style={{ display:"flex",gap:16,alignItems:"flex-start" }}>
                  <div style={{ width:24,height:24,borderRadius:"50%",background:"#111",color:"#fff",fontSize:10,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1 }}>{i+1}</div>
                  <div>
                    <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:4 }}>{a.label}</p>
                    <p style={{ fontSize:12.5,color:"#666",lineHeight:1.6 }}>{a.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Sec>

        {/* ── 02 Compliance Stepper ── */}
        <Sec>
          <span className="mlabel">Design Decision 02</span>
          <h2 className="lh" style={{ marginBottom:16 }}>One item at a time. Cannot skip forward.</h2>
          <p className="bt" style={{ marginBottom:16 }}>
            Showing all 25 checklist items on one screen overwhelmed workers — they scrolled past items without completing them.
            I chose a step-by-step flow so users only focused on one safety decision at a time. Although this added a few extra taps,
            it <span className="hl">significantly reduced missed compliance steps</span>.
          </p>

          <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:32 }} className="three-col">
            {[
              { tag:"✗ Rejected", label:"Scrollable list", body:"All 25 items visible. Fast but too easy to scroll past." },
              { tag:"✗ Rejected", label:"Accordion sections", body:"Better structure, but all headers still visible — decision paralysis." },
              { tag:"✓ Chosen", label:"Step-by-step stepper", body:"One question. One screen. Cannot skip forward. Progress always visible.", chosen:true },
            ].map((o,i)=>(
              <div key={i} style={{ padding:"20px 20px",background: o.chosen ? "#111" : "#fff" }}>
                <p style={{ fontSize:11,fontWeight:700,color: o.chosen ? "#fff" : "#aaa",marginBottom:8 }}>{o.tag}</p>
                <p style={{ fontSize:13,fontWeight:700,color: o.chosen ? "#fff" : "#111",marginBottom:6 }}>{o.label}</p>
                <p style={{ fontSize:12.5,color: o.chosen ? "#aaa" : "#888",lineHeight:1.6 }}>{o.body}</p>
              </div>
            ))}
          </div>

          <div style={{ display:"flex",gap:0,alignItems:"flex-start",background:"#fff",border:"1px solid #e8e8e8",flexDirection:isMobile?"column":"row" }}>
            <div style={{ flex:1,minWidth:0,padding:"clamp(20px,4vw,40px) clamp(20px,4vw,36px)",display:"flex",flexDirection:"column",gap:20 }}>
              {[
                { label:"Step 7 of 25 — progress always visible", body:"Workers know exactly where they are. Completion feels achievable. The progress bar eliminates the 'how much is left?' anxiety." },
                { label:"OFFLINE MODE — no data loss", body:"Badge tells workers answers are saved locally. No fear of losing 7 completed steps if signal drops mid-form in an industrial site." },
                { label:"One question fills the entire screen", body:"One visual. One question. The full screen is dedicated to one decision. No scanning. No skipping possible." },
                { label:"48px buttons — designed for gloves", body:"Full-width, minimum 48px. No accidental mis-taps for workers wearing industrial gloves in outdoor lighting." },
                { label:"Contextual warning, not generic", body:"'Hot work permits cannot be issued without suppression tools on-site.' Only appears for items where it's actually relevant." },
              ].map((a,i)=>(
                <div key={i} style={{ display:"flex",gap:16,alignItems:"flex-start" }}>
                  <div style={{ width:24,height:24,borderRadius:"50%",background:"#111",color:"#fff",fontSize:10,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1 }}>{i+1}</div>
                  <div>
                    <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:4 }}>{a.label}</p>
                    <p style={{ fontSize:12.5,color:"#666",lineHeight:1.6 }}>{a.body}</p>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ flexShrink:0,width:isMobile?"100%":"42%",background:"#eef3ff",display:"flex",alignItems:"center",justifyContent:"center",padding:isMobile?"28px 20px":"40px 32px" }}>
              <div className="ph" style={{ width:isMobile?"100%":240,maxWidth:280 }}><img src={screen2} alt="Stepper" /></div>
            </div>
          </div>

          <div style={{ marginTop:20,padding:"20px 24px",borderLeft:"3px solid #111",background:"#fff" }}>
            <p className="bq" style={{ fontSize:14 }}>Experienced workers may find the stepper slower. Accepted — in a safety-critical environment, the cost of a rushed mistake is infinitely higher than 30 extra seconds.</p>
          </div>
        </Sec>

        {/* ── 03 Input Types ── */}
        <Sec>
          <span className="mlabel">Design Decision 03</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Input-type affordances — no instruction reading required.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            The original checklist had 4 input types — all looking identical. The problem: workers had to read instructions to know how to answer each item.
            My decision was to give every input type its own visual affordance. The reason: <span className="hl">a user should never need to read instructions</span> to know how to answer.
          </p>
          <div style={{ display:"flex",gap:0,alignItems:"flex-start",background:"#fff",border:"1px solid #e8e8e8",flexDirection:isMobile?"column":"row" }}>
            <div style={{ flexShrink:0,width:isMobile?"100%":"42%",background:"#f0faf5",display:"flex",alignItems:"center",justifyContent:"center",padding:isMobile?"28px 20px":"40px 32px" }}>
              <div className="ph" style={{ width:isMobile?"100%":240,maxWidth:280 }}><img src={screen3} alt="Input types" /></div>
            </div>
            <div style={{ flex:1,minWidth:0,padding:"clamp(20px,4vw,40px) clamp(20px,4vw,36px)",display:"flex",flexDirection:"column",gap:20 }}>
              {[
                { label:"VERIFICATION → Yes / No buttons", body:"Badge announces the input type. Two 48px full-width buttons — no ambiguity about how to answer." },
                { label:"UPLOAD → dashed drag area + cloud icon", body:"Universal affordance. Workers know to tap and select a file. No written instruction anywhere on screen." },
                { label:"CAMERA → live camera preview", body:"Live preview tells workers to point their phone. Not type. Not tap a form. Point their camera." },
                { label:"NUMERIC ENTRY → field + unit inline", body:"'% LEL' visible inside the field. Numbers only. Safety-critical measurements need validated, typed inputs." },
              ].map((a,i)=>(
                <div key={i} style={{ display:"flex",gap:16,alignItems:"flex-start" }}>
                  <div style={{ width:24,height:24,borderRadius:"50%",background:"#111",color:"#fff",fontSize:10,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1 }}>{i+1}</div>
                  <div>
                    <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:4 }}>{a.label}</p>
                    <p style={{ fontSize:12.5,color:"#666",lineHeight:1.6 }}>{a.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Sec>

        {/* ── 04 Geo Validation ── */}
        <Sec>
          <span className="mlabel">Design Decision 04</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Geo-validation as a hard gate — explained, not hidden.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            Submit is locked until the worker is within 100m of the work site. The problem with a silently disabled button:
            it <span className="hl">feels like a broken app</span>, not an intentional safety rule. My decision was that every locked state must explain itself —
            the tradeoff being more screen real estate spent on explanation instead of action.
          </p>
          <div style={{ display:"flex",gap:0,alignItems:"flex-start",background:"#fff",border:"1px solid #e8e8e8",flexDirection:isMobile?"column":"row" }}>
            <div style={{ flex:1,minWidth:0,padding:"clamp(20px,4vw,40px) clamp(20px,4vw,36px)",display:"flex",flexDirection:"column",gap:20 }}>
              {[
                { label:"Red banner — action required, not error", body:"'Location verification required before submission' — tells the worker what to do, not just that something failed." },
                { label:"Live distance — '6.3km away'", body:"Exact number shown. Not a vague block. Workers know precisely how far they need to travel to unlock submission." },
                { label:"PERMIT GATE: LOCKED — rule explicit", body:"'Within 100m of the work site.' The threshold is clear. No ambiguity about what would unlock submission." },
                { label:"GPS → WiFi → Cell fallback chain", body:"Signal health + accuracy bars are shown. Workers see the system is actively trying. Technology adapts, gate stays." },
                { label:"'Why am I blocked?' explanation", body:"Two bullet explanation of the safety rationale. Treating workers as intelligent adults builds trust in the system's rules." },
                { label:"Submit locked · Retry = primary CTA", body:"Lock icon on Submit. Orange 'Retry Location Sync' guides to the exact correct next action." },
              ].map((a,i)=>(
                <div key={i} style={{ display:"flex",gap:16,alignItems:"flex-start" }}>
                  <div style={{ width:24,height:24,borderRadius:"50%",background:"#111",color:"#fff",fontSize:10,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1 }}>{i+1}</div>
                  <div>
                    <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:4 }}>{a.label}</p>
                    <p style={{ fontSize:12.5,color:"#666",lineHeight:1.6 }}>{a.body}</p>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ flexShrink:0,width:isMobile?"100%":"42%",background:"#fff5f5",display:"flex",alignItems:"center",justifyContent:"center",padding:isMobile?"28px 20px":"40px 32px" }}>
              <div className="ph" style={{ width:isMobile?"100%":240,maxWidth:280 }}><img src={screen4} alt="Geo validation" /></div>
            </div>
          </div>
        </Sec>

        {/* ── 05 + 06 side by side ── */}
        <Sec>
          <span className="mlabel">Design Decisions 05 & 06</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Compliance summary + action hierarchy for the Permit Issuer.</h2>
          <p className="bt" style={{ marginBottom:36 }}>
            The Permit Issuer was scrolling through 25 raw checklist answers to make one decision. My decision: a
            <span className="hl"> 4-tile compliance summary</span> that enables a go/no-go in under 10 seconds, paired with button hierarchy
            where visual weight matches action consequence. The tradeoff — some granular detail is hidden by default — was worth the speed gain for a daily, repetitive decision.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="two-col">
            <div style={{ background:"#fff" }}>
              <div style={{ background:"#eef4ff",display:"flex",justifyContent:"center",padding:"32px" }}>
                <div className="ph" style={{ width:isMobile?"100%":220,maxWidth:260 }}><img src={screen5} alt="Compliance summary" /></div>
              </div>
              <div style={{ padding:"24px 24px",display:"flex",flexDirection:"column",gap:16 }}>
                {[
                  { label:"4 tiles replace 25 line items", body:"Critical Checks ✓, JSA ✓, Inspection ⚠, Location ✗ — decision in under 10 seconds." },
                  { label:"COMPLETE / NEEDS REVIEW / MISSING", body:"Green / amber / red. Colour alone communicates status — no reading needed." },
                ].map((a,i)=>(
                  <div key={i} style={{ display:"flex",gap:12,alignItems:"flex-start" }}>
                    <div style={{ width:20,height:20,borderRadius:"50%",background:"#111",color:"#fff",fontSize:9,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1 }}>{i+1}</div>
                    <div>
                      <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:3 }}>{a.label}</p>
                      <p style={{ fontSize:12,color:"#666",lineHeight:1.6 }}>{a.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ background:"#fff" }}>
              <div style={{ background:"#f0fff5",display:"flex",justifyContent:"center",padding:"32px" }}>
                <div className="ph" style={{ width:isMobile?"100%":220,maxWidth:260 }}><img src={screen6} alt="Approval decision" /></div>
              </div>
              <div style={{ padding:"24px 24px",display:"flex",flexDirection:"column",gap:16 }}>
                {[
                  { label:"APPROVE — full-width, dominant", body:"Largest, highest-contrast element. The correct action is visually the most obvious action." },
                  { label:"Return — outlined, secondary weight", body:"Present but not competing. Medium consequence = medium visual prominence." },
                  { label:"Reject — text only, quietest", body:"Text-only, smallest, no fill. Destructive actions earn the least visual weight." },
                ].map((a,i)=>(
                  <div key={i} style={{ display:"flex",gap:12,alignItems:"flex-start" }}>
                    <div style={{ width:20,height:20,borderRadius:"50%",background:"#111",color:"#fff",fontSize:9,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1 }}>{i+1}</div>
                    <div>
                      <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:3 }}>{a.label}</p>
                      <p style={{ fontSize:12,color:"#666",lineHeight:1.6 }}>{a.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Sec>

        {/* ── 07 + 08 side by side ── */}
        <Sec>
          <span className="mlabel">Design Decisions 07 & 08</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Gas readings first + the hard gate in action.</h2>
          <p className="bt" style={{ marginBottom:36 }}>
            The F&S screen surfaces <span className="hl">atmospheric gas readings above everything else</span> — because that's the data that determines if hot work is safe.
            Screen 08 shows what a hard gate looks like in practice — the mandatory blocker that can't be talked around.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="two-col">
            <div style={{ background:"#fff" }}>
              <div style={{ background:"#fff8f0",display:"flex",justifyContent:"center",padding:"32px" }}>
                <div className="ph" style={{ width:isMobile?"100%":220,maxWidth:260 }}><img src={screen7} alt="F&S review" /></div>
              </div>
              <div style={{ padding:"24px 24px",display:"flex",flexDirection:"column",gap:16 }}>
                {[
                  { label:"HC% LEL surfaced first, always", body:"0.0% vs limit <10%. The reading that decides if welding near gas lines is safe. It appears before anything else on screen." },
                  { label:"O2% + H2S PPM with safe ranges", body:"Each gas card shows the reading, the safe limit, and a visual bar. At-a-glance status without calculation." },
                  { label:"Two actions only — Return or Approve", body:"F&S is a safety gate, not a final decision-maker. No permanent Reject. Role-appropriate actions only." },
                ].map((a,i)=>(
                  <div key={i} style={{ display:"flex",gap:12,alignItems:"flex-start" }}>
                    <div style={{ width:20,height:20,borderRadius:"50%",background:"#111",color:"#fff",fontSize:9,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1 }}>{i+1}</div>
                    <div>
                      <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:3 }}>{a.label}</p>
                      <p style={{ fontSize:12,color:"#666",lineHeight:1.6 }}>{a.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ background:"#fff" }}>
              <div style={{ background:"#f8f0ff",display:"flex",justifyContent:"center",padding:"32px" }}>
                <div className="ph" style={{ width:isMobile?"100%":220,maxWidth:260 }}><img src={screen8} alt="Hard gate" /></div>
              </div>
              <div style={{ padding:"24px 24px",display:"flex",flexDirection:"column",gap:16 }}>
                {[
                  { label:"MANDATORY — not 'recommended'", body:"The word is unambiguous. Safety language must be absolute. JSA Document is required, not optional." },
                  { label:"'Submission Blocked' — names the exact issue", body:"'The JSA is missing' — specific. Worker knows precisely what to upload to unblock submission." },
                  { label:"Upload JSA = primary CTA", body:"Orange, full-width — the system points to the solution, not just the problem. Guided, not punitive." },
                  { label:"Save Offline + Supervisor as escape valves", body:"Edge cases handled without removing the gate. If JSA can't be uploaded now — save progress or escalate." },
                ].map((a,i)=>(
                  <div key={i} style={{ display:"flex",gap:12,alignItems:"flex-start" }}>
                    <div style={{ width:20,height:20,borderRadius:"50%",background:"#111",color:"#fff",fontSize:9,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1 }}>{i+1}</div>
                    <div>
                      <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:3 }}>{a.label}</p>
                      <p style={{ fontSize:12,color:"#666",lineHeight:1.6 }}>{a.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ CONSTRAINTS & TRADEOFFS ══════════════════════════════ */}
        <Sec>
          <span className="mlabel">Constraints & Tradeoffs</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Designing for people who don't think of themselves as app users.</h2>
          <p className="bt" style={{ marginBottom:40 }}>
            Most primary users had decades of industrial experience but very limited experience using mobile applications for safety workflows.
            Instead of expecting workers to learn new interaction patterns, I designed the system around <span className="hl">familiar inspection processes</span> —
            the same mental model they'd used on paper for years, just digitized.
          </p>

          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:1 }} className="two-col">
            <div style={{ padding:"32px 28px",background:"#fff",borderTop:"3px solid #111" }}>
              <p style={{ fontSize:11,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#aaa",marginBottom:12 }}>Who is actually using this</p>
              <p style={{ fontSize:28,fontWeight:800,color:"#111",lineHeight:1.2,marginBottom:14,letterSpacing:"-0.02em" }}>55–60 year old engineers and safety officers — not digital natives.</p>
              <p style={{ fontSize:14,color:"#666",lineHeight:1.75 }}>
                Senior Permit Issuers and F&S Officers have decades of experience with paper-based systems. Many hold their phone with two hands. Many read screens at arm's length. Many have never used a form-based app before this one.
              </p>
            </div>
            <div style={{ background:"#fff",padding:"32px 28px",borderTop:"3px solid #111" }}>
              <p style={{ fontSize:11,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#aaa",marginBottom:16 }}>What this meant for every design decision</p>
              <div style={{ display:"flex",flexDirection:"column",gap:14 }}>
                {[
                  { constraint:"No abbreviations, anywhere", decision:"Every label is a full word. 'Work Permit Request', not 'WPR'. 'Approve Permit', not 'Approve'. Senior users cannot guess abbreviations they've never seen." },
                  { constraint:"Large text and high contrast", decision:"All body text minimum 14px. All action labels minimum 15px bold. Colour contrast above WCAG AA across all interactive elements." },
                  { constraint:"One action per screen", decision:"No multi-step forms. No side-by-side choices. One decision. One screen. Senior users with lower digital fluency need clear, unambiguous paths." },
                  { constraint:"Familiar metaphors only", decision:"'Approve Permit' not 'Sign off'. 'Reject Permit' not 'Decline'. Language borrowed from the paper system they already know." },
                ].map((c,i)=>(
                  <div key={i} style={{ paddingBottom:14,borderBottom: i<3 ? "1px solid #f0f0f0" : "none" }}>
                    <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:4 }}>{c.constraint}</p>
                    <p style={{ fontSize:12.5,color:"#666",lineHeight:1.6 }}>{c.decision}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{ border:"1px solid #e8e8e8",background:"#e8e8e8",display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:1 }} className="three-col">
            <div style={{ padding:"14px 20px",background:"#fafafa" }}>
              <p style={{ fontSize:11,fontWeight:700,color:"#aaa",letterSpacing:".12em",textTransform:"uppercase" }}>Constraint</p>
            </div>
            <div style={{ padding:"14px 20px",background:"#fafafa" }}>
              <p style={{ fontSize:11,fontWeight:700,color:"#aaa",letterSpacing:".12em",textTransform:"uppercase" }}>Tradeoff accepted</p>
            </div>
            <div style={{ padding:"14px 20px",background:"#fafafa" }}>
              <p style={{ fontSize:11,fontWeight:700,color:"#aaa",letterSpacing:".12em",textTransform:"uppercase" }}>Why it was worth it</p>
            </div>
            {[
              { c:"No direct user access — designed from a 28-page BRD and stakeholder calls only", t:"Design decisions couldn't be validated with actual users before delivery", w:"Deep BRD analysis + domain research + stakeholder iteration replaced missing user testing. Every decision has a documented rationale." },
              { c:"Senior, non-tech-savvy users (55–60 yrs) as primary approvers", t:"The stepper flow is slower for the rare tech-fluent user who knows the checklist by memory", w:"For non-tech users, speed is irrelevant if they make errors. A 30-second slower experienced user beats one missed gas test." },
              { c:"Industrial field environment — gloves, outdoor lighting, variable connectivity", t:"Large touch targets and high contrast reduce visual density — less information per screen", w:"Information density is a desktop metric. In the field, clarity beats density every time. One clear action beats six visible options." },
              { c:"Hard geo-validation gate — submit locked outside 100m", t:"Workers with weak GPS inside metal structures experience frustrating false blocks", w:"GPS → WiFi → Cell fallback chain mitigates most cases. Remaining edge cases are solved by Supervisor escalation, not gate removal." },
              { c:"Compliance stepper — one item at a time, no skipping", t:"Experienced workers who know all 25 checklist items find the stepper pace slow", w:"Skipped checklist items in hot work environments are a safety incident risk, not an inconvenience. The gate doesn't move." },
              { c:"Role-based rendering requires clean backend role data", t:"If a user's role is wrong in the system, they see the wrong home screen", w:"Flagged as a hard dependency at handoff. Backend role integrity is a process requirement, not a UX workaround." },
            ].map((row,i)=>(
              <>
                <div key={`a${i}`} style={{ padding:"18px 20px",background:"#fff" }}>
                  <p style={{ fontSize:13,color:"#333",lineHeight:1.6 }}>{row.c}</p>
                </div>
                <div key={`b${i}`} style={{ padding:"18px 20px",background:"#fff" }}>
                  <p style={{ fontSize:13,color:"#ef4444",lineHeight:1.6 }}>{row.t}</p>
                </div>
                <div key={`c${i}`} style={{ padding:"18px 20px",background:"#fff" }}>
                  <p style={{ fontSize:13,color:"#555",lineHeight:1.6 }}>{row.w}</p>
                </div>
              </>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ CORE PRINCIPLE ══════════════════════════════════════ */}
        <Sec>
          <span className="mlabel">Core Principle</span>
          <h2 className="lh" style={{ marginBottom:20 }}>The gate doesn't move. The path to the gate gets smoother.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            Every edge case was solved by making the <span className="hl">approach to the hard gate easier</span> — not by removing the gate.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="three-col">
            {[
              { scenario:"Bad network", solution:"Offline-first save — every answer stored locally as the worker goes. Uploaded when signal returns. Gate stays, progress doesn't disappear." },
              { scenario:"Missing equipment", solution:"Flag & escalate — mark as 'Pending with reason'. A human makes the safety call. The system doesn't bypass its own gate." },
              { scenario:"Weak GPS indoors", solution:"GPS → WiFi → Cell fallback. Radius tightens as accuracy decreases. Safety intent preserved, technology adapts to reality." },
            ].map((e,i)=>(
              <div key={i} style={{ padding:"24px 22px",background:"#fff" }}>
                <p style={{ fontSize:11,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#aaa",marginBottom:10 }}>{e.scenario}</p>
                <p style={{ fontSize:13,color:"#444",lineHeight:1.7 }}>{e.solution}</p>
              </div>
            ))}
          </div>
        </Sec>

        {/* ── FUTURE OPPORTUNITIES (NEW) ── */}
        <Sec>
          <span className="mlabel">Future Opportunities</span>
          <h2 className="lh" style={{ marginBottom:16 }}>If I were extending this system today.</h2>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="four-col">
            {[
              { t:"AI Permit Assistant", b:"Suggest missing safety checks before submission." },
              { t:"Predictive Risk Alerts", b:"Warn supervisors about similar historical incidents." },
              { t:"Offline Synchronization", b:"Improve automatic conflict resolution when connectivity returns." },
              { t:"Supervisor Dashboard", b:"Provide live visibility into permit bottlenecks." },
            ].map((c,i)=>(
              <div key={i} style={{ padding:"22px 20px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{c.t}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{c.b}</p>
              </div>
            ))}
          </div>
        </Sec>

        {/* ══ LEARNINGS ══════════════════════════════════════════ */}
        <Sec>
          <span className="mlabel">Retrospective</span>
          <h2 className="lh" style={{ marginBottom:32 }}>What this project taught me.</h2>
          {[
            { t:"The best UX for safety-critical systems is invisible", b:"I learned that when a design is working, users don't notice it — they just complete the task correctly. The goal isn't delight. It's zero errors." },
            { t:"Constraints are not obstacles — they are the design brief", b:"Gloves, poor lighting, weak GPS, low connectivity — each one pushed me toward a better decision. The stepper, 48px targets, offline save, and location fallback wouldn't exist without the constraints that demanded them." },
            { t:"In safety-critical products, reducing mistakes matters more than reducing clicks", b:"A safety checklist that can be bypassed isn't a safety checklist. I learned to resist the instinct to optimise for fewer taps when the cost of one missed step is so much higher than the cost of a few extra seconds." },
            { t:"System mapping before screen design pays off later", b:"Without direct user access, I spent Day 1 mapping 4 roles, 28 BRD pages, and every decision point. That investment gave every subsequent screen decision a clear rationale I could defend." },
            { t:"Naming tradeoffs explicitly builds trust in the work", b:"The stepper is slower for experienced users. The geo-gate frustrates workers in metal structures. I learned to state both as accepted tradeoffs with documented reasoning, rather than treat them as flaws to apologise for." },
          ].map((item,i,arr)=>(
            <div key={i} style={{ display:"flex",gap:24,padding:"24px 0",borderBottom: i<arr.length-1 ? "1px solid #e8e8e8" : "none",alignItems:"flex-start" }}>
              <p style={{ fontSize:13,fontWeight:700,color:"#ccc",flexShrink:0,minWidth:28 }}>0{i+1}</p>
              <div>
                <p style={{ fontSize:15,fontWeight:700,color:"#111",marginBottom:6 }}>{item.t}</p>
                <p style={{ fontSize:14,color:"#666",lineHeight:1.8 }}>{item.b}</p>
              </div>
            </div>
          ))}
        </Sec>

        {/* ── NEXT ── */}
        <div onClick={()=>navigate("/case-study/cloudevolve")}
          style={{ padding:"32px 32px",border:"1px solid #e8e8e8",background:"#fff",cursor:"pointer",transition:"border-color .2s" }}
          onMouseEnter={e=>{e.currentTarget.style.borderColor="#111"}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor="#e8e8e8"}}>
          <p style={{ fontSize:10,fontWeight:600,letterSpacing:".16em",textTransform:"uppercase",color:"#aaa",marginBottom:8 }}>Next case study</p>
          <h3 style={{ fontSize:20,fontWeight:800,letterSpacing:"-0.02em" }}>Cloud Cost Optimization Platform →</h3>
          <p style={{ fontSize:13,color:"#aaa",marginTop:6 }}>FinOps SaaS · Web Application · B2B</p>
        </div>

      </main>
    </div>
  );
}